import React from "react";

const ExportErrorIcon = ({ width = 16, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.7648 8.72718L6.99086 4.87475C6.95507 4.8386 6.9094 4.81836 6.86127 4.81836H5.769C5.67767 4.81836 5.6357 4.95139 5.70482 5.02079L9.13811 8.52764H0.0987361C0.0444311 8.52764 0 8.5797 0 8.64332V9.5109C0 9.57452 0.0444311 9.62657 0.0987361 9.62657H9.13688L5.70358 13.1334C5.63447 13.2043 5.67643 13.3359 5.76776 13.3359H6.89706C6.92051 13.3359 6.94396 13.3257 6.96124 13.3069L10.7648 9.42703C10.8075 9.3835 10.8418 9.32974 10.8653 9.26937C10.8887 9.20901 10.9009 9.14345 10.9009 9.07711C10.9009 9.01077 10.8887 8.94521 10.8653 8.88484C10.8418 8.82448 10.8075 8.77071 10.7648 8.72718Z"
      fill="#E4001C"
    />
    <path
      d="M10.7197 0.298828C10.8678 0.298951 11.0087 0.358327 11.1133 0.462891L14.8682 4.2168C14.9727 4.32145 15.0322 4.46507 15.0322 4.61328V15.3711C15.0322 15.6798 14.7824 15.9296 14.4736 15.9297H3.30859C2.99981 15.9297 2.75 15.6799 2.75 15.3711V10.8135H4.00586V14.6738H13.7754V6.05566H10.0078C9.81349 6.05566 9.62667 5.97823 9.48926 5.84082C9.35203 5.70351 9.27451 5.51737 9.27441 5.32324V1.55469H4.00586V7.22559H2.75V0.856445C2.75023 0.547855 2.99995 0.298828 3.30859 0.298828H10.7197ZM10.4609 4.86914H13.7441L10.4609 1.58594V4.86914Z"
      fill="#E4001C"
    />
  </svg>
);

export default ExportErrorIcon;
